import { render, staticRenderFns } from "./SearchLayerPlugin.vue?vue&type=template&id=2b098c44&scoped=true"
import script from "./SearchLayerPlugin.vue?vue&type=script&lang=ts"
export * from "./SearchLayerPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SearchLayerPlugin.vue?vue&type=style&index=0&id=2b098c44&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2b098c44",
  null
  ,true
)

export default component.exports